import useOutsideClick from "hooks/useOutsideClick";
import moment from "jalali-moment";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

const Noti = () => {
    const messages = useSelector(state => state.main.messages);

    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, () => setShowDropdown(false));

    if (messages.noPermission)
        return <></>;

    return (
        <div className="noti mr-3 relative" ref={wrapperRef}>
            <button className="tp-7" onClick={() => setShowDropdown(prev => !prev)} title="اطلاعیه ها">
                {
                    messages.fetched ? (
                        messages.data.count > 0 && (
                            <span className="badge-c1">
                                {messages.data.count}
                            </span>
                        )
                    ) : (
                        <span className="badge-c1">
                            <i className="fa-solid fa-spinner spin"></i>
                        </span>
                    )
                }

                <i className="fa-regular fa-bell"></i>
            </button >

            <CSSTransition in={showDropdown} timeout={{ enter: 200, exit: 0 }} unmountOnExit={true}>
                <div className="dropdown absolute left-0 rounded-sm anim-c1">
                    {
                        messages.fetched ? (
                            !messages.error ? (
                                <>
                                    {/* <div className="flex py-4 px-3 items-center text-xs justify-center border-b border-[#E8E8F7] dark:border-[#323244]">
                                        <span className="font-medium text-[#3c4858] dark:text-[#D0D0E2]">
                                            {
                                                messages.data.count > 0
                                                    ? `شما ${messages.data.count} اطلاعیه خوانده نشده دارید`
                                                    : `اطلاعیه جدیدی وجود ندارد`
                                            }
                                        </span>

                                        <Link to="/panel/message" className="bg-primary-100 hover:bg-primary-200 transition-colors text-white rounded-full p-1 px-2 mr-1">
                                            مشاهده همه
                                        </Link>
                                    </div> */}

                                    {
                                        messages.data.count > 0 && (
                                            <div className="border-b border-[#F2ECFB] dark:border-[#323244] relative bg-white dark:bg-secondary">
                                                {
                                                    messages.data.list.map((noti, i) => (
                                                        <div className="noti-item relative" key={`notification-${i}`}>
                                                            <div className="iBox">
                                                                <i className="fa-solid fa-messages"></i>
                                                            </div>

                                                            <div className="col-left">
                                                                <p>{noti.text}</p>
                                                                <span>{moment.unix(noti.created_at).format("hh:mm jYYYY/jMM/jDD")}</span>
                                                            </div>

                                                            <Link to={`/panel/message/${noti.id}`} className="pos-cover" onClick={() => setShowDropdown(false)} />
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )
                                    }

                                    <Link to="/panel/message" className="py-3 text-center block text-sm font-medium text-primary-100  bg-white dark:bg-secondary relative" onClick={() => setShowDropdown(false)}>
                                        مشاهده همه اطلاعیه ها
                                    </Link>
                                </>
                            ) : <span>error</span>
                        ) : <span>loading</span>
                    }

                </div>
            </CSSTransition >
        </div >
    )
}

export default Noti;